<template>
  <JobCard :jobInfo="jobInfo" showStatus @showFooter="onShowFooter">
    <div slot="header" class="job-status">{{ jobInfo.stateDesc }}</div>
    <div slot="resume" class="resume-name">
        投递简历：{{
        jobInfo.type === "ATTACHMENT" ? jobInfo.fileName : jobInfo.typeDesc
      }}(<a style="border: red">投递时间：{{ jobInfo.deliveryDate }}</a>)

    </div>
    <div slot="footer" v-loading="loading">
      <el-steps :active="active" finish-status="success">
        <el-step
          v-for="(node, index) in nodes"
          :key="index"
          :title="node.stateDesc"
          :description="node.reason"
          :status="colorToStatus[node.colour]"
        ></el-step>
      </el-steps>
    </div>
  </JobCard>
</template>

<script>
import JobCard from "./JobCard.vue";
export default {
  props: {
    jobInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // active: this.jobInfo.state,
      active: 4,
      nodes: [],
      isCache: false,
      loading: false,
      colorToStatus: {
        red: "error",
        gray: "wait",
        blue: "success"
      }
    };
  },
  components: {
    JobCard
  },
  methods: {
    async getNodes(deliverId) {
      this.loading = true;
      const res = await this.$axios({
        url: `/portal/delivery/record/${deliverId}`,
        mothod: "GET"
      });
      this.loading = false;
      if (res.code === 200) {
        this.nodes = res.data;
      }
    },
    onShowFooter(isShow) {
      if (!this.isCache && isShow && this.jobInfo.deliverId) {
        this.getNodes(this.jobInfo.deliverId);
        this.isCache = true;
      }
    }
  }
};
</script>

<style lang="scss">
.job-status {
  font-size: 14px;
}
.resume-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}
</style>
